<script>
  import {Router, Link, Route} from 'svelte-routing';
  import Home from './route/Home.svelte';
  import About from './route/About.svelte';
  import VTKSimulator from './route/VTKSimulator.svelte';
  import Button from './components/Button.svelte';

  import HomeIcon from 'svelte-material-icons/Home.svelte';
  import Robot from 'svelte-material-icons/Robot.svelte';
  import LightbulbOn from 'svelte-material-icons/LightbulbOn.svelte'
</script>
  
<main>
  <div class='app'>
    <Router>
      <header class='header'>
        <Link to="/"><Button type="tab"><HomeIcon/></Button></Link>
        <Link to="about"><Button type="tab"><Robot/></Button></Link>
        <Link to="experiment"><Button type="tab"><LightbulbOn/></Button></Link>
      </header>
      
      <div class='contents'>
        <Route path ="/"><Home/></Route> 
        <Route path ="about" component={About}/>
        <Route path = "experiment" component={VTKSimulator}/>
      </div>
    </Router>
  </div>
</main>

  
  
  
<style>
.app{
  position: absolute;
  
  justify-content: flex-start;
	align-items: flex-start;	
	flex-direction: column;
  overflow-y : scroll;

  width: 100%;
  height: 100%;

  top:0px;
  left:0px;

  background-color: blueviolet;
}

.header {
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width : 50px;
  height: 100%;
  background-color: rgb(36, 32, 32);

}

.contents{
  position: absolute;

  left: 50px;
  width: 100%;
  height : 100%;
  background-color: #f5c399;
} 

</style>